module.exports = __webpack_public_path__ + "img/anushka.098baee0.webp";